import React  from 'react';
import { Link } from "react-router-dom";

import './Nav.css';
class Nav extends React.Component {

    constructor(props) {
        super(props);

        // This binding is necessary to make `this` work in the callback
        this.clearSearch = this.clearSearch.bind(this);
        this.execSearch  = this.execSearch.bind(this);
    }

    execSearch(event) {
        const search = event.target.value;
        this.setState({search });
        //setTimeout(()=>{
            this.props.setNavSearch(search ); // trigger refresh
        //},1);

        //if (typeof window.Auth.sessionclient.search!=="object") window.Auth.sessionclient.search= {};
        //window.Auth.sessionclient.search[this.props.match.params.doc] = search ;

    }

    clearSearch(){
        this.setState({search: ""});
        this.props.setNavSearch(""); // trigger refresh
        this.props.setClearSearch(true)
        //if (typeof window.Auth.sessionclient.search!=="object") window.Auth.sessionclient.search= {};
        //window.Auth.sessionclient.search[this.props.match.params.doc]  = "";

    }

    componentDidMount(){
        this.nameInput.focus();
    }

    render() {

        //console.log("@*@ nav render search", this.props.search)
        const logo = "/img-nvvc-logo-84x84.png";

        //let signoutname, userInitials;
        if (!this.props.appuser) {
            //console.log("### ERROR Nav render WITHOUT appuser?!", this.props);
            return <div className="spinner">Error no appuser</div>
        }

        return ( <div>
                    <div className = "navbar navbar-light navbar-expand-lg bg-light fixed-top" >
                        <Link  to="/search">
                            <div className="navbrandlogodiv">
                                <img alt="logo" className="navbrandlogo" src={logo}/>
                            </div>
                        </Link>
                        <div id="navsearch" className="input-group mb-3">
                            <input id="filtersearch" value={this.props.search} onChange={this.execSearch}  
                            ref={(input) => { this.nameInput = input; }} 
                            className="form-control" 
                            placeholder="Zoek NVVC-lid, instelling, commissie/werkgroep, mandaat of aandachtsgebied" 
                            aria-label="Search" type="text"  />
                            <div className="input-group-append">
                                <button title="clear search" onClick={this.clearSearch} className="btn btn-outline-secondary">
                                    <img alt="x" src="/img-button-remove.svg" />
                                </button>
                            </div>
                        </div>
                    </div>
            </div>


        );

    }

}

export default Nav;




// WEBPACK FOOTER //
// ./src/Nav.js